"use client";

import { useEffect, useState } from "react";
import { KeycapButton } from "@/components/ui/KeycapButton";
import { MobileNavDialog } from "./MobileNavDialog";
import { pillLinks } from "@/config/navigation";
import { site } from "@/config/site";
import { cn } from "@/lib/utils";

function BrandGlyph() {
  return (
    <span className="inline-flex items-center gap-2.5">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        aria-hidden="true"
        className="shrink-0"
      >
        <rect width="22" height="22" rx="6" fill="#0B1220" />
        <path
          d="M8.4 15.6c-.6-.5-.9-1.3-.9-2.3 0-.4.1-.8.2-1.2h1.9c-.1.3-.2.6-.2.9 0 .6.2 1 .5 1.3.3.3.8.4 1.3.4.6 0 1-.2 1.4-.5.3-.3.5-.7.5-1.2 0-.4-.1-.7-.4-1-.2-.3-.6-.5-1-.7l-1-.5c-1-.4-1.6-.9-2-1.4-.4-.6-.6-1.2-.6-2 0-1 .3-1.9 1-2.5.6-.6 1.5-.9 2.5-.9 1 0 1.8.3 2.4.8.6.5.9 1.3.9 2.2 0 .4-.1.8-.2 1.2h-1.9c.1-.3.2-.6.2-.9 0-.5-.1-.9-.4-1.1-.3-.3-.6-.4-1.1-.4-.5 0-.9.1-1.2.4-.3.3-.4.6-.4 1.1 0 .4.1.7.3.9.2.3.6.5 1 .7l1 .5c1 .4 1.6.9 2 1.4.5.6.7 1.3.7 2.1 0 1.1-.4 1.9-1.1 2.6-.7.6-1.6.9-2.8.9-1 0-1.9-.3-2.6-.8Z"
          fill="#1A56DB"
        />
      </svg>
      <span className="font-sans text-[15px] font-semibold leading-none text-text">
        {site.name}
      </span>
    </span>
  );
}

export function PillNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "pill-nav fixed left-1/2 z-[100] -translate-x-1/2 rounded-full border backdrop-blur-[18px] transition-[top,padding,border-color,background-color] duration-[var(--duration-base)] ease-[var(--ease-standard)]",
        "top-6",
        scrolled ? "border-[rgba(255,255,255,0.14)]" : "border-[var(--color-hairline)]",
      )}
    >
      <div
        className={cn(
          "flex items-center gap-3 transition-[padding] duration-[var(--duration-base)]",
          scrolled ? "p-1" : "p-2",
        )}
      >
        <a href="#hero" className="flex items-center rounded-full px-2 py-1" aria-label={`${site.name} — úvod`}>
          <BrandGlyph />
        </a>

        <nav aria-label="Hlavní navigace" className="hidden items-center gap-1 lg:flex">
          {pillLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-full px-3 py-2 text-[14px] font-medium text-text-muted transition-colors duration-[var(--duration-fast)] hover:text-text"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href={`mailto:${site.email}`}
          className="mono-label hidden rounded-full px-2 py-1 text-text-muted transition-colors duration-[var(--duration-fast)] hover:text-text xl:inline"
        >
          Napište nám
        </a>

        <div className="hidden lg:block">
          <KeycapButton href="#poptavka" variant="signal" size="sm">
            Chci nabídku
          </KeycapButton>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <KeycapButton href="#poptavka" variant="signal" size="sm">
            Chci nabídku
          </KeycapButton>
          <MobileNavDialog />
        </div>
      </div>
    </header>
  );
}
